// @ts-ignore
import lottie from 'react-native-web-lottie';

export const LottieView = lottie;
